import { type ReactNode, useCallback } from 'react';
import {
  Flex,
  Space,
  type TableProps,
  Typography,
  theme,
} from '@timeedit/ui-components/antd';

const { useToken } = theme;

type UseTableTitleOptions = {
  total: number;
  filteredAmount?: number;
  resultType?: string;
  showTotalNumber?: boolean;
  actions?: {
    left?: ReactNode;
    right?: ReactNode;
  };
};

export function useTableTitle<T extends object>({
  total,
  filteredAmount = total,
  resultType = 'results',
  showTotalNumber = true,
  actions: { left: leftActions = null, right: rightActions = null } = {},
}: UseTableTitleOptions) {
  const { token } = useToken();

  return useCallback<Exclude<TableProps<T>['title'], undefined>>(
    () => (
      <Flex
        justify="space-between"
        align="center"
        style={{
          padding: '8px',
          width: '100%',
          height: '38px',
          backgroundColor: token.colorBgLayout,
        }}
      >
        <Space>
          {showTotalNumber && (
            <Typography.Text
              style={{
                color: token.colorTextHeading,
              }}
            >
              {`Showing ${filteredAmount} of ${total} ${resultType}`}
            </Typography.Text>
          )}
        </Space>
        {rightActions}
      </Flex>
    ),
    [
      filteredAmount,
      rightActions,
      token.colorBgLayout,
      token.colorTextHeading,
      total,
    ]
  );
}
